export const API_BASE_URL = 'https://booking-api.neighborfood.ca';
// export const API_BASE_URL = 'http://localhost:3002';

export const CMS_BASE_URL = 'https://cms.neighborfood.ca';

export const API_ENDPOINTS = {
  VIEW: `${API_BASE_URL}/view`,
  AVAILABILITIES: `${API_BASE_URL}/availabilities`,
  RESERVATION: `${API_BASE_URL}/reservation`,
  ALL_PRODUCTS: `${API_BASE_URL}/all_products`,
  HOME_PRODUCTS: `${API_BASE_URL}/home_products`,
  POSTAL: `${API_BASE_URL}/postal`,
  EMAIL_OTHER_REGION: `${API_BASE_URL}/email-other-region`,
  MAIN_CATEGORIES: `${API_BASE_URL}/main_categories`,
}; 